/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface InternalService {
  /** @summary Healthcheck */
  healthcheckHealthcheckGet: {
    /** @summary Healthcheck */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<HealthcheckHealthcheckGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: HealthcheckHealthcheckGetSchema,
        options: {
          parameters: HealthcheckHealthcheckGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>>
    ): Promise<RequestFnResponse<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>>;
    /** @summary Healthcheck */
    getQueryKey(
      parameters: DeepReadonly<HealthcheckHealthcheckGetParameters> | void
    ): ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.internalService.healthcheckHealthcheckGet.useQuery()
     * ```
     */
    useQuery<TData = HealthcheckHealthcheckGetData>(
      parameters:
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError,
          TData,
          ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<HealthcheckHealthcheckGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.internalService.healthcheckHealthcheckGet.useQuery()
     * ```
     */
    useQuery<TData = HealthcheckHealthcheckGetData>(
      parameters:
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError,
          TData,
          ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<HealthcheckHealthcheckGetError>>;
    /** @summary Healthcheck */
    getInfiniteQueryKey(
      parameters: DeepReadonly<HealthcheckHealthcheckGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.healthcheckHealthcheckGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends HealthcheckHealthcheckGetParameters,
      TQueryFnData = HealthcheckHealthcheckGetData,
      TData = OperationInfiniteData<TQueryFnData, HealthcheckHealthcheckGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          HealthcheckHealthcheckGetError,
          TData,
          ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<HealthcheckHealthcheckGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.healthcheckHealthcheckGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends HealthcheckHealthcheckGetParameters,
      TQueryFnData = HealthcheckHealthcheckGetData,
      TData = OperationInfiniteData<TQueryFnData, HealthcheckHealthcheckGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          HealthcheckHealthcheckGetError,
          TData,
          ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<HealthcheckHealthcheckGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<HealthcheckHealthcheckGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const healthcheckHealthcheckGetTotal = qraft.internalService.healthcheckHealthcheckGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const healthcheckHealthcheckGetResults = qraft.internalService.healthcheckHealthcheckGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * healthcheckHealthcheckGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const healthcheckHealthcheckGetCombinedResults = qraft.internalService.healthcheckHealthcheckGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * healthcheckHealthcheckGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          HealthcheckHealthcheckGetSchema,
          HealthcheckHealthcheckGetParameters,
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.internalService.healthcheckHealthcheckGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = HealthcheckHealthcheckGetData>(
      parameters:
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError,
          TData,
          ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<HealthcheckHealthcheckGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.healthcheckHealthcheckGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends HealthcheckHealthcheckGetParameters,
      TData = HealthcheckHealthcheckGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError,
          OperationInfiniteData<TData, HealthcheckHealthcheckGetParameters>,
          ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<HealthcheckHealthcheckGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, HealthcheckHealthcheckGetParameters>,
      OperationError<HealthcheckHealthcheckGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Healthcheck
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const healthcheckHealthcheckGetData = qraft.internalService.healthcheckHealthcheckGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * healthcheckHealthcheckGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const healthcheckHealthcheckGetCombinedData = qraft.internalService.healthcheckHealthcheckGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * healthcheckHealthcheckGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          HealthcheckHealthcheckGetSchema,
          HealthcheckHealthcheckGetParameters,
          HealthcheckHealthcheckGetData,
          HealthcheckHealthcheckGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Healthcheck */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<HealthcheckHealthcheckGetData>;
    /** @summary Healthcheck */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<void>;
    /** @summary Healthcheck */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<HealthcheckHealthcheckGetData>;
    /** @summary Healthcheck */
    fetchInfiniteQuery<TPageParam extends HealthcheckHealthcheckGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        DeepReadonly<TPageParam>,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>>;
    /** @summary Healthcheck */
    prefetchInfiniteQuery<TPageParam extends HealthcheckHealthcheckGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        DeepReadonly<TPageParam>,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<void>;
    /** @summary Healthcheck */
    ensureInfiniteQueryData<TPageParam extends HealthcheckHealthcheckGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        HealthcheckHealthcheckGetParameters,
        DeepReadonly<TPageParam>,
        HealthcheckHealthcheckGetError
      > | void
    ): Promise<OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>>;
    /** @summary Healthcheck */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void)
    ): HealthcheckHealthcheckGetData | undefined;
    /** @summary Healthcheck */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void)
    ): OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters> | undefined;
    /** @summary Healthcheck */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              HealthcheckHealthcheckGetSchema,
              HealthcheckHealthcheckGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
            data: HealthcheckHealthcheckGetData | undefined,
          ]
        >;
    /** @summary Healthcheck */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | void)
    ): QueryState<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetError> | undefined;
    /** @summary Healthcheck */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<HealthcheckHealthcheckGetParameters>
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>,
          HealthcheckHealthcheckGetError
        >
      | undefined;
    /** @summary Healthcheck */
    setQueryData(
      parameters:
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | undefined)
        | ServiceOperationQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
      updater: Updater<
        NoInfer<HealthcheckHealthcheckGetData> | undefined,
        NoInfer<DeepReadonly<HealthcheckHealthcheckGetData>> | undefined
      >,
      options?: SetDataOptions
    ): HealthcheckHealthcheckGetData | undefined;
    /** @summary Healthcheck */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<HealthcheckHealthcheckGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<HealthcheckHealthcheckGetSchema, HealthcheckHealthcheckGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>> | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<HealthcheckHealthcheckGetData, HealthcheckHealthcheckGetParameters> | undefined;
    /** @summary Healthcheck */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >,
      updater: Updater<
        NoInfer<HealthcheckHealthcheckGetData> | undefined,
        NoInfer<HealthcheckHealthcheckGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<HealthcheckHealthcheckGetData | undefined>;
    /** @summary Healthcheck */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        HealthcheckHealthcheckGetSchema,
        HealthcheckHealthcheckGetData,
        TInfinite,
        HealthcheckHealthcheckGetParameters,
        HealthcheckHealthcheckGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Healthcheck */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Healthcheck */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Healthcheck */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
    ): void;
    /** @summary Healthcheck */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Healthcheck */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
        | QueryFiltersByQueryKey<
            HealthcheckHealthcheckGetSchema,
            HealthcheckHealthcheckGetData,
            TInfinite,
            HealthcheckHealthcheckGetParameters,
            HealthcheckHealthcheckGetError
          >
    ): number;
    schema: HealthcheckHealthcheckGetSchema;
    types: {
      parameters: HealthcheckHealthcheckGetParameters;
      data: HealthcheckHealthcheckGetData;
      error: HealthcheckHealthcheckGetError;
    };
  };
  /** @summary Test Celery */
  testCeleryCeleryHelloGet: {
    /** @summary Test Celery */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<TestCeleryCeleryHelloGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: TestCeleryCeleryHelloGetSchema,
        options: {
          parameters: TestCeleryCeleryHelloGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>>
    ): Promise<RequestFnResponse<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>>;
    /** @summary Test Celery */
    getQueryKey(
      parameters: DeepReadonly<TestCeleryCeleryHelloGetParameters> | void
    ): ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.internalService.testCeleryCeleryHelloGet.useQuery()
     * ```
     */
    useQuery<TData = TestCeleryCeleryHelloGetData>(
      parameters:
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError,
          TData,
          ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<TestCeleryCeleryHelloGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.internalService.testCeleryCeleryHelloGet.useQuery()
     * ```
     */
    useQuery<TData = TestCeleryCeleryHelloGetData>(
      parameters:
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError,
          TData,
          ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<TestCeleryCeleryHelloGetError>>;
    /** @summary Test Celery */
    getInfiniteQueryKey(
      parameters: DeepReadonly<TestCeleryCeleryHelloGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.testCeleryCeleryHelloGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends TestCeleryCeleryHelloGetParameters,
      TQueryFnData = TestCeleryCeleryHelloGetData,
      TData = OperationInfiniteData<TQueryFnData, TestCeleryCeleryHelloGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          TestCeleryCeleryHelloGetError,
          TData,
          ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<TestCeleryCeleryHelloGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.testCeleryCeleryHelloGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends TestCeleryCeleryHelloGetParameters,
      TQueryFnData = TestCeleryCeleryHelloGetData,
      TData = OperationInfiniteData<TQueryFnData, TestCeleryCeleryHelloGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          TestCeleryCeleryHelloGetError,
          TData,
          ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TestCeleryCeleryHelloGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<TestCeleryCeleryHelloGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const testCeleryCeleryHelloGetTotal = qraft.internalService.testCeleryCeleryHelloGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const testCeleryCeleryHelloGetResults = qraft.internalService.testCeleryCeleryHelloGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * testCeleryCeleryHelloGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const testCeleryCeleryHelloGetCombinedResults = qraft.internalService.testCeleryCeleryHelloGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * testCeleryCeleryHelloGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          TestCeleryCeleryHelloGetSchema,
          TestCeleryCeleryHelloGetParameters,
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.internalService.testCeleryCeleryHelloGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = TestCeleryCeleryHelloGetData>(
      parameters:
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError,
          TData,
          ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<TestCeleryCeleryHelloGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.internalService.testCeleryCeleryHelloGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends TestCeleryCeleryHelloGetParameters,
      TData = TestCeleryCeleryHelloGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError,
          OperationInfiniteData<TData, TestCeleryCeleryHelloGetParameters>,
          ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TestCeleryCeleryHelloGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, TestCeleryCeleryHelloGetParameters>,
      OperationError<TestCeleryCeleryHelloGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Test Celery
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const testCeleryCeleryHelloGetData = qraft.internalService.testCeleryCeleryHelloGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * testCeleryCeleryHelloGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const testCeleryCeleryHelloGetCombinedData = qraft.internalService.testCeleryCeleryHelloGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * testCeleryCeleryHelloGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          TestCeleryCeleryHelloGetSchema,
          TestCeleryCeleryHelloGetParameters,
          TestCeleryCeleryHelloGetData,
          TestCeleryCeleryHelloGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Test Celery */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<TestCeleryCeleryHelloGetData>;
    /** @summary Test Celery */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<void>;
    /** @summary Test Celery */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<TestCeleryCeleryHelloGetData>;
    /** @summary Test Celery */
    fetchInfiniteQuery<TPageParam extends TestCeleryCeleryHelloGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        DeepReadonly<TPageParam>,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>>;
    /** @summary Test Celery */
    prefetchInfiniteQuery<TPageParam extends TestCeleryCeleryHelloGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        DeepReadonly<TPageParam>,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<void>;
    /** @summary Test Celery */
    ensureInfiniteQueryData<TPageParam extends TestCeleryCeleryHelloGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TestCeleryCeleryHelloGetParameters,
        DeepReadonly<TPageParam>,
        TestCeleryCeleryHelloGetError
      > | void
    ): Promise<OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>>;
    /** @summary Test Celery */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void)
    ): TestCeleryCeleryHelloGetData | undefined;
    /** @summary Test Celery */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void)
    ): OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters> | undefined;
    /** @summary Test Celery */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              TestCeleryCeleryHelloGetSchema,
              TestCeleryCeleryHelloGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
            data: TestCeleryCeleryHelloGetData | undefined,
          ]
        >;
    /** @summary Test Celery */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | void)
    ): QueryState<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetError> | undefined;
    /** @summary Test Celery */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<TestCeleryCeleryHelloGetParameters>
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>,
          TestCeleryCeleryHelloGetError
        >
      | undefined;
    /** @summary Test Celery */
    setQueryData(
      parameters:
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | undefined)
        | ServiceOperationQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
      updater: Updater<
        NoInfer<TestCeleryCeleryHelloGetData> | undefined,
        NoInfer<DeepReadonly<TestCeleryCeleryHelloGetData>> | undefined
      >,
      options?: SetDataOptions
    ): TestCeleryCeleryHelloGetData | undefined;
    /** @summary Test Celery */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<TestCeleryCeleryHelloGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<TestCeleryCeleryHelloGetSchema, TestCeleryCeleryHelloGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<TestCeleryCeleryHelloGetData, TestCeleryCeleryHelloGetParameters> | undefined;
    /** @summary Test Celery */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >,
      updater: Updater<
        NoInfer<TestCeleryCeleryHelloGetData> | undefined,
        NoInfer<TestCeleryCeleryHelloGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<TestCeleryCeleryHelloGetData | undefined>;
    /** @summary Test Celery */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        TestCeleryCeleryHelloGetSchema,
        TestCeleryCeleryHelloGetData,
        TInfinite,
        TestCeleryCeleryHelloGetParameters,
        TestCeleryCeleryHelloGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Test Celery */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Test Celery */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Test Celery */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
    ): void;
    /** @summary Test Celery */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Test Celery */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
        | QueryFiltersByQueryKey<
            TestCeleryCeleryHelloGetSchema,
            TestCeleryCeleryHelloGetData,
            TInfinite,
            TestCeleryCeleryHelloGetParameters,
            TestCeleryCeleryHelloGetError
          >
    ): number;
    schema: TestCeleryCeleryHelloGetSchema;
    types: {
      parameters: TestCeleryCeleryHelloGetParameters;
      data: TestCeleryCeleryHelloGetData;
      error: TestCeleryCeleryHelloGetError;
    };
  };
}
/** @summary Healthcheck */
export const healthcheckHealthcheckGet = {
  schema: {
    method: 'get',
    url: '/healthcheck',
  },
} as {
  schema: HealthcheckHealthcheckGetSchema;
  [QraftServiceOperationsToken]: InternalService['healthcheckHealthcheckGet'];
};
/** @summary Test Celery */
export const testCeleryCeleryHelloGet = {
  schema: {
    method: 'get',
    url: '/celery/hello',
  },
} as {
  schema: TestCeleryCeleryHelloGetSchema;
  [QraftServiceOperationsToken]: InternalService['testCeleryCeleryHelloGet'];
};
export const internalService = {
  healthcheckHealthcheckGet,
  testCeleryCeleryHelloGet,
} as const;
type HealthcheckHealthcheckGetSchema = {
  method: 'get';
  url: '/healthcheck';
};
type HealthcheckHealthcheckGetParameters = undefined;
type HealthcheckHealthcheckGetData = paths['/healthcheck']['get']['responses']['200']['content']['application/json'];
type HealthcheckHealthcheckGetError = unknown;
type TestCeleryCeleryHelloGetSchema = {
  method: 'get';
  url: '/celery/hello';
};
type TestCeleryCeleryHelloGetParameters = undefined;
type TestCeleryCeleryHelloGetData = paths['/celery/hello']['get']['responses']['200']['content']['application/json'];
type TestCeleryCeleryHelloGetError = unknown;
